import React, { useState } from 'react';
import { TextField, Button, Box, Grid, CircularProgress, Typography, InputAdornment, Alert } from '@mui/material';
import { FaLock, FaEye, FaEyeSlash, FaCheckCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { passwordChange, sendPasswordCode } from '../../../../redux/actions/profileActions';
import useAlert from '../../../../hooks/useAlert';
import { validateChangePassword } from '../../../../utils/validation';

const PasswordChange = ({ email }) => {
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);
  const dispatch = useDispatch();
  const { showSuccessPasswordCode, showErrorAlertPasswordCode, showSuccessChangePassword, showErrorAlertChangePassword } = useAlert();
  const { loading, error } = useSelector((state) => state.auth);
  const handleInputChangePassword = (e) => {
    const { name, value } = e.target;
    setFormValuesPassword({ ...formValuesPassword, [name]: value });
  };
  const token = useSelector(state => state?.auth?.user?.accessToken?.token);
  const [formValuesPassword, setFormValuesPassword] = useState({
    password: "",
    rePassword: "",
    code: "",
    email: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const passwordUpdateCode = async (e) => {
    e.preventDefault();
    formValuesPassword.email = email;
    await dispatch(sendPasswordCode(formValuesPassword, token));
    setIsPasswordChanged(true);
    showSuccessPasswordCode();
  };

  const passwordUpdate = async (e) => {
    formValuesPassword.id = authUserId;
    e.preventDefault();
    const errors = validateChangePassword(formValuesPassword);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      try {
        await dispatch(passwordChange(formValuesPassword, token));
        showSuccessChangePassword();
        setIsPasswordChanged(false);
      } catch {
        showErrorAlertChangePassword();
      }

    }
  };

  return (
    <Box component="form" onSubmit={isPasswordChanged ? passwordUpdate : passwordUpdateCode} sx={{ mt: 3 }}>
      {isPasswordChanged ? <Grid container spacing={2}>


        <Grid item xs={12}>
          <TextField
            size='small'


            name="password"
            fullWidth
            label="Yeni Şifre"
            type={showPassword ? 'text' : 'password'}
            value={formValuesPassword.password}
            onChange={handleInputChangePassword}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaLock color="#6C63FF" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end" onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                  {showPassword ? <FaEyeSlash color="#6C63FF" /> : <FaEye color="#6C63FF" />}
                </InputAdornment>
              ),
            }}
            error={!!formErrors.password}
            helperText={formErrors.password}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            size='small'


            name="rePassword"
            fullWidth
            label="Şifre tekrarı"
            type={showRePassword ? 'text' : 'password'}
            value={formValuesPassword.rePassword}
            onChange={handleInputChangePassword}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaCheckCircle color="#6C63FF" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end" onClick={() => setShowRePassword(!showRePassword)} style={{ cursor: 'pointer' }}>
                  {showRePassword ? <FaEyeSlash color="#6C63FF" /> : <FaEye color="#6C63FF" />}
                </InputAdornment>
              ),
            }}
            error={!!formErrors.rePassword}
            helperText={formErrors.rePassword}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            size='small'


            name="code"
            fullWidth
            label="Onay kodu"
            type='number'
            value={formValuesPassword.code}
            onChange={handleInputChangePassword}
            error={!!formErrors.code}
            helperText={formErrors.code}
          />
        </Grid>
      </Grid> :
        <Alert variant="outlined" severity="info">
          Şifre değiştirmek için doğrulama gerekli.
        </Alert>
      }
      {isPasswordChanged ? (
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              mt: 4,
              mb: 2,
              borderRadius: 18,
              backgroundColor: '#1F1B45',
              color: '#FFFFFF',
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              padding: '10px 20px',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&:hover': {
                backgroundColor: '#2C285A',
              },
            }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Kaydet'}
          </Button>
        </Grid>
      ) : (
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              mt: 4,
              mb: 2,
              borderRadius: 2,
              backgroundColor: '#1F1B45',
              color: '#FFFFFF',
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              padding: '10px 20px',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&:hover': {
                backgroundColor: '#2C285A',
              },
            }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Kod Gönder'}
          </Button>
        </Grid>
      )}

      {error && <Typography color="error">{error.message}</Typography>}
    </Box>
  );
};

export default PasswordChange;
